import * as types from '@/store/types'
export default {
    jumps: state => {
        return state.jumps
    },
    modelDefault: state => {
        return state.modelDefault
    },
    getJumpInHistoryCashByTypeAndParentId: state => params => {
        return state.jumpsHistoryCash.find(jump => jump.type === params.type && jump.parent_id === params.parentId)
    }
}
